/* ePixel - carduri fara optiuni de varianta: in locul selectorului punem o eticheta
   cu disponibilitatea reala (in stoc / ultimele bucati / stoc epuizat), in aceeasi forma
   ca selectorul, ca randul sa fie simetric pe toata grila.
   Datele vin din x-labels-data, randat de tema. */
(function () {
  if (window.__pbStockChip) return;
  window.__pbStockChip = true;

  var LOW = 4;
  var language = (document.documentElement.lang || 'ro').toLowerCase().split('-')[0];
  var dictionary = {
    ro: { availability: 'Disponibilitate', available: 'În stoc', soldOut: 'Stoc epuizat', notify: 'Te anunțăm când revine', delivery: 'Livrare în 24–48h', low: function (qty) { return 'Ultimele ' + qty + (qty === 1 ? ' bucată' : ' bucăți'); } },
    hu: { availability: 'Elérhetőség', available: 'Készleten', soldOut: 'Elfogyott', notify: 'Értesítünk, ha újra elérhető', delivery: 'Szállítás 24–48 órán belül', low: function (qty) { return 'Utolsó ' + qty + ' darab'; } }
  };
  var copy = dictionary[language] || dictionary.ro;

  function readData(card) {
    var el = card.querySelector('[x-labels-data]');
    if (!el) return null;
    try {
      var arr = JSON.parse(el.getAttribute('x-labels-data'));
      return arr && arr.length ? arr[0] : null;
    } catch (e) { return null; }
  }

  function icon(kind) {
    if (kind === 'out') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M6 18 18 6"/></svg>';
    }
    if (kind === 'low') {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8v5"/><path d="M12 16.5h.01"/><circle cx="12" cy="12" r="9"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7.5 10.5 17 4.5 11"/></svg>';
  }

  function build(card) {
    var row = card.querySelector('.pbx-row--empty');
    if (!row || row.querySelector('.pbx-stock')) return;
    var d = readData(card);
    if (!d) return;

    var out = d.available === false;
    var tracked = d.inventory_management === 'shopify';
    var qty = typeof d.qty === 'number' ? d.qty : null;
    var low = !out && tracked && qty !== null && qty > 0 && qty <= LOW;
    var kind = out ? 'out' : (low ? 'low' : 'ok');

    var title = out ? copy.soldOut : (low ? copy.low(qty) : copy.available);
    var sub = out ? copy.notify : copy.delivery;

    var chip = document.createElement('div');
    chip.className = 'pbx-stock is-' + kind;
    chip.innerHTML =
      '<span class="pbx-stock-label">' + copy.availability + '</span>' +
      '<span class="pbx-trigger pbx-trigger--static pbx-stock-chip">' +
        '<span class="pbx-thumb pbx-stock-icon">' + icon(kind) + '</span>' +
        '<span class="pbx-text">' +
          '<span class="pbx-code">' + title + '</span>' +
          '<span class="pbx-name">' + sub + '</span>' +
        '</span>' +
      '</span>';
    row.appendChild(chip);
    row.classList.add('pbx-row--stock');
  }

  function scan() {
    document.querySelectorAll('.card-product.pbx-has-buy').forEach(function (c) {
      try { build(c); } catch (e) {}
    });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(scan, 150); }

  function start() {
    scan();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && ((n.matches && (n.matches('.card-product') || n.matches('.pbx-row'))) || (n.querySelector && n.querySelector('.card-product, .pbx-row')))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
